import React, { useRef } from 'react';
import s from './ActionsMenu.module.css';
import { DropdownMenu } from './DropdownMenu';

export function ActionsMenuEditIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M20.1428 20.4826H11.8649M1.00003 21L6.7421 18.7915C7.10938 18.6502 7.29301 18.5796 7.46482 18.4874C7.61743 18.4055 7.76291 18.3109 7.89975 18.2047C8.0538 18.0852 8.19292 17.9461 8.47117 17.6678L20.1428 5.99619C21.2858 4.85325 21.2858 3.00016 20.1428 1.85721C18.9999 0.714264 17.1468 0.714263 16.0038 1.85721L4.3322 13.5288C4.05395 13.8071 3.91482 13.9462 3.79528 14.1003C3.6891 14.2371 3.59455 14.3826 3.51263 14.5352C3.42041 14.707 3.34978 14.8906 3.20852 15.2579L1.00003 21ZM1.00003 21L3.12966 15.463C3.28205 15.0668 3.35825 14.8687 3.48894 14.778C3.60316 14.6987 3.74448 14.6687 3.88106 14.6947C4.03735 14.7246 4.18744 14.8747 4.48762 15.1749L6.8252 17.5124C7.12538 17.8126 7.27547 17.9627 7.30531 18.119C7.33139 18.2556 7.3014 18.3969 7.2221 18.5111C7.13135 18.6418 6.93324 18.718 6.53702 18.8704L1.00003 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ActionsMenuDotsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ActionsMenu({
  open = false,
  onToggle,
  items = [],
  containerRef = null,
  title = 'Меню',
  align = 'right',
  trigger = <ActionsMenuEditIcon />,
  wrapClassName = s.wrap,
  buttonClassName = s.button,
  menuClassName = '',
  portal = false,
  anchorRef = null,
  portalZIndex,
}) {
  const buttonRef = useRef(null);
  const menuAnchorRef = anchorRef || buttonRef;

  return (
    <div className={wrapClassName} ref={containerRef}>
      <button
        type="button"
        ref={buttonRef}
        title={title}
        onClick={onToggle}
        className={buttonClassName}
        aria-label={title}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {trigger}
      </button>

      <DropdownMenu
        open={open}
        items={items}
        align={align}
        className={menuClassName}
        portal={portal}
        anchorRef={menuAnchorRef}
        portalZIndex={portalZIndex}
      />
    </div>
  );
}
